<template>
  <div class="container app-bg-color banners" ref="container">
    <div class="panel">
      <div class="panel-heading">
        <div class="panel-label">
          <h3>{{$t('BANNERS.title')}}</h3>
        </div>
      </div>

      <div class="panel-body row">
        <div class="col-12">
          <el-form ref="formbanner" label-width="auto" :model="form">
            <el-form-item :label="$t('BANNERS.timer')" size="mini" prop="timer" :rules="{ required: true, message: 'Please input Timer', trigger: ['blur', 'change'] }">
              <el-select v-model="form.timer" placeholder="Select time in seconds" size="mini">
                <el-option
                  v-for="item in 5"
                  :key="`time${item}`"
                  :label="getLabel(item)"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('BANNERS.slidescount')" >
              <el-select v-model="form.ammount" @change="ammountChange" placeholder="Select" size="mini">
                <el-option
                  :key="0"
                  :label="0"
                  :value="0">
                </el-option>
                <el-option
                  v-for="item in 5"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <div v-for="(slide, index) in form.slides" :key="index">
              <banner-slide :slide="slide" :index="index" @imageChanged="imageChanged" :shops="getShops">
              </banner-slide>
            </div>

            <el-form-item>
              <el-button type="primary" @click="onSubmit">{{$t('BANNERS.update')}}</el-button>
              <!-- <el-button>Cancel</el-button> -->
            </el-form-item>
          </el-form>
        </div>
      </div>

    </div>
  </div>
</template>

<script type="text/babel">
import axios from 'axios'
import {mapActions, mapGetters, mapMutations} from 'vuex'
import { BannersPerimeter } from '../../../router/perimeters/bannersPerimeter';
import BannerSlide from './BannerSlide'

export default {
    name: 'BannersView',
    data () {
        return {
          form: {
            ammount: 0,
            timer: 1,
            slides: []
          }
        };
    },
    components: { BannerSlide },
    perimeters: [BannersPerimeter],
    computed: {
      ...mapGetters({
            getBanner: 'getBanner',
            getLanguages: 'getLanguages',
            getShops: 'getShopList'
       }),
    },
    methods: {
      ...mapActions([
        'getBannerAsync',
        'setBannerAsync',
        'getLanguagesAsync'
      ]),
      ...mapMutations([
        'updateBanner',
      ]),
      ammountChange(value){
        let slidesCount = this.form.slides.length;
        if(value === 0){
          this.form.slides = []
          this.updateBanner(this.form)
          return;
        }
        if(slidesCount > value){
          this.form.slides.splice(value -1, slidesCount -1)
        }else {
          for (let index = slidesCount; index < value; index++) {
            this.form.slides.push({
              "image": "",
              "texts": this.getLanguages,
              "shops": [],
              "link": {
                  "android": "",
                  "ios": ""
              }
            })
          }
        }
      },
      imageChanged({name, index}){
        this.form.slides[index].image = name
      },
      onSubmit(e){
         this.$refs['formbanner'].validate((valid) => {
          if (valid) {
            this.setBannerAsync(this.form)
          } else {
            return false;
          }
        });
      },
      getLabel(value) {
        return value == 1 ? '1 second' : `${value} seconds`
      }
    },
    mounted () {
    },
    async created(){
      const data = await this.getBannerAsync()
      this.form = data

      await this.getLanguagesAsync()
    }
};
</script>

<style lang="scss">
.without-suffix {
  .el-input__suffix {
    display: none !important;
    background: #ff0;
  }
}
</style>

<style lang="scss" scoped>
.stats-img {
  img {
    width: 28%;
    height: auto;
  }
}
h4 {
  font-size: 1rem;
}

h5 {
  font-size: 0.8rem;
}
.shopdropdown li {
  display: block;
  height: auto;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
  border-bottom: solid 1px #eee;
}
.shop-name,
.shop-address,
.shop-external-id {
  display: block;
  width: 100%;
  line-height: 1.2;
  font-weight: 300;
}
.shop-name {
  font-size: 0.9rem;
}
.shop-address {
  font-size: 0.8rem;
  color: #aaa;
}
.shop-external-id {
  font-size: 0.8rem;
  color: #aaa;
}
.key-accounts,
.email-input {
  width: 100%;
}
.el-date-editor {
  width: calc(50% - 0.25rem);
}
.el-radio-group {
  display: flex;
}
</style>
